<template>
  <div class="text-center text-gray-500 flex-1 flex justify-center flex-col">
    <div class="text-4xl font-bold">403</div>
    <div class="text-xl font-semibold">ERROR</div>
    <div class="text-lg">You are not allowed to view this page</div>
  </div>
</template>

<script>
export default {
  name: "Forbidden"
};
</script>
